import OrganizationServiceClient from '@/api/OrganizationServiceClient';

const defaultState = {
  addresses: [],
};

const mutations = {
  setAddresses(state, addresses) {
    state.addresses = addresses;
  },
};

const actions = {
  async getAddresses({ commit, rootGetters }, { dealershipId }) {
    const organizationServiceClient = new OrganizationServiceClient(
      rootGetters.currentUser,
    );

    const payload = {
      page: 0,
      pageSize: 100,
    };

    let addresses = [];
    let hasNextPage = true;

    while (hasNextPage) {
      // eslint-disable-next-line no-await-in-loop
      const response = await organizationServiceClient
        .getPaginatedDealershipAddresses(dealershipId, payload);

      const { data } = response.data;
      const { meta } = response.data;

      addresses = addresses.concat(data.addresses); // Append the addresses from the current page
      hasNextPage = meta.hasNextPage; // Update the hasNextPage flag based on the response

      payload.page += 1; // Increment the page number for the next request
    }

    commit('setAddresses', addresses.map((a) => ({ ...a, zipCode: a.postalCode })));
  },
};

const getters = {
  organizationAddreses: (state) => () => state.addreses,
};

export default {
  state: defaultState,
  mutations,
  actions,
  getters,
};
